// extracted by mini-css-extract-plugin
module.exports = {"DomainForm":"DomainForm_DomainForm__3IGQ3","DomainForm_inputSection":"DomainForm_DomainForm_inputSection__27xEA","DomainForm_textInput":"DomainForm_DomainForm_textInput__2pGVl"};